/**
 * 프로덕션 빌드에서 브라우저 개발자 도구 콘솔 출력을 비웁니다.
 * REACT_APP_ENABLE_CONSOLE_LOGS=true 또는 REACT_APP_DEBUG=true 이면 억제하지 않습니다.
 * index.tsx에서 다른 import보다 먼저 로드해야 합니다.
 */
const consoleEnabledInProd =
  process.env.REACT_APP_ENABLE_CONSOLE_LOGS === 'true' ||
  process.env.REACT_APP_DEBUG === 'true';

if (process.env.NODE_ENV === 'production' && !consoleEnabledInProd) {
  const noop = (): void => {};
  /* eslint-disable no-console */
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
  console.trace = noop;
  console.dir = noop;
  console.dirxml = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  console.table = noop;
  /* eslint-enable no-console */
}

export {};
